<div class="scroll-top" (click)="onScrollToTop()"></div>